import React from "react";

var chatSvg = function chatSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.315 11.974l-.723 3.814a.268.268 0 0 1-.069.135.241.241 0 0 1-.353 0l-2.78-2.93c-.13.004-.26.007-.39.007-4.418 0-8-2.91-8-6.5S3.582 0 8 0s8 2.91 8 6.5c0 2.299-1.469 4.319-3.685 5.474z",
    fillRule: "evenodd"
  }));
};

chatSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var chat = {
  category: 'icon',
  colorable: true,
  name: 'chat',
  svg: chatSvg
};